export default "__VITE_ASSET__BKkeKF_L__"